"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExportPriorityTasks = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const export_priority_tasks_mutation_1 = require("./export-priority-tasks.mutation");
const download_file_1 = require("../../../common/download-file");
const use_notification_hook_1 = require("../../../../hooks/use-notification.hook");
const localization_1 = require("../../../../localization");
const useExportPriorityTasks = ({ catalogId, productTreeId, filter, sort, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addError } = (0, use_notification_hook_1.useNotification)();
    const [exportMutation, { loading }] = (0, react_2.useMutation)(export_priority_tasks_mutation_1.EXPORT_PRIORITY_TASKS);
    const exportPriorityTasks = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { data } = yield exportMutation({
                variables: {
                    input: {
                        catalog: catalogId,
                        productTreeId,
                        clientMutationId: '',
                        filter,
                        sort,
                    },
                },
            });
            const result = data === null || data === void 0 ? void 0 : data.exportPriorityTasks;
            if (result === null || result === void 0 ? void 0 : result.error) {
                throw new Error(result.error);
            }
            if (result === null || result === void 0 ? void 0 : result.downloadUrl) {
                (0, download_file_1.downloadFile)(result.downloadUrl);
            }
        }
        catch (_a) {
            addError(t({ key: 'EXPORT_CSV_ERROR' }));
        }
    }), [exportMutation, catalogId, productTreeId, filter, sort, t, addError]);
    return {
        exportPriorityTasks,
        loading,
    };
};
exports.useExportPriorityTasks = useExportPriorityTasks;
